@layer module {
.account-details__grid {
            display: grid;
    }

.detail-tile {
            display: flex;
            align-items: center;
    }

.detail-tile__text {
            flex-grow: 1;
    }

.detail-tile__value {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
    }

.detail-tile__value--wrap {
            overflow-wrap: anywhere;
            white-space: normal;
    }

.detail-tile__copy {
            display: grid;
            flex-shrink: 0;
            place-items: center;
            border: none;
            cursor: pointer;
    }

.detail-tile__copy:disabled {
            cursor: default;
    }
} // layer module










@layer app {
.account-details__grid {
            grid-template-columns: repeat(auto-fit, minmax(max($size-220, calc((100% - $size-30) / 4)), 1fr));
            gap: $size-10;
    }

.detail-tile {
            gap: $size-8;
            padding: $size-12 $size-10 $size-12 $size-16;
            border-radius: $size-14;
    }

.detail-tile__text {
            min-width: 0;
    }

.detail-tile__copy {
            min-width: $size-32;
            height: $size-32;
            padding: 0 $size-6;
            border-radius: $size-9;
    }

.detail-tile__copy svg {
            width: $size-14;
            height: $size-14;
    }

.detail-tile {
            background: var(--page-canvas);
    }

.detail-tile__label {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }

.detail-tile__value {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-variant-numeric: tabular-nums;
            font-weight: 500;
    }

.detail-tile__value.empty {
            color: var(--text-secondary);
    }

.detail-tile__copy {
            background: transparent;
            color: var(--text-body);
    }

.detail-tile__copy:hover:where(:not(:disabled)) {
            background: var(--bg-surface);
    }

.detail-tile__copy:disabled {
            color: var(--text-faint);
    }

.detail-tile__copied {
            color: var(--color-success-text);
            font-size: var(--font-size-sm);
            font-weight: 500;
    }
} // layer app
